import { Link } from 'react-router-dom';
import { trackEvent } from '../lib/tracking';
import { WHATSAPP_BASE, WHATSAPP_GENERIC_MESSAGE } from '../lib/constants';

const servicos = ['Carpete modular', 'Carpete em placas', 'Instalação profissional'];

export default function HeroSection() {
  return (
    <section className="relative bg-background-50 overflow-hidden">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8 pt-28 md:pt-36 pb-16 md:pb-24">
        {/* Breadcrumb */}
        <nav aria-label="Trilha de navegação" className="mb-8">
          <ol className="flex items-center gap-1.5 text-[12px] text-foreground-400">
            <li>
              <Link to="/" className="hover:text-foreground-700 transition-colors">
                Início
              </Link>
            </li>
            <li aria-hidden="true" className="text-foreground-300">
              /
            </li>
            <li>
              <Link to="/produtos" className="hover:text-foreground-700 transition-colors">
                Soluções
              </Link>
            </li>
            <li aria-hidden="true" className="text-foreground-300">
              /
            </li>
            <li className="text-foreground-700">Carpete Corporativo</li>
          </ol>
        </nav>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Texto */}
          <div>
            <p className="inline-flex items-center gap-2 text-[12px] md:text-[13px] font-semibold tracking-[0.28em] uppercase text-primary-500 mb-5">
              <span className="w-6 h-px bg-primary-500 inline-block"></span>
              Carpete corporativo
            </p>

            <h1 className="text-foreground-950 text-[30px] md:text-[44px] font-semibold tracking-tight leading-[1.1] mb-5">
              Carpete corporativo para ambientes que exigem conforto acústico, estética e desempenho.
            </h1>

            <p className="text-foreground-500 text-[16px] md:text-[18px] leading-relaxed mb-7 max-w-xl">
              Especificação, fornecimento e instalação de carpetes para escritórios, salas de
              reunião, hotéis, auditórios e ambientes empresariais.
            </p>

            {/* Linha de serviços */}
            <div className="flex flex-wrap gap-x-2 gap-y-2 mb-8 text-[13px] text-foreground-600 font-medium">
              {servicos.map((s, i) => (
                <span key={s} className="inline-flex items-center gap-2">
                  {i > 0 && <span className="text-foreground-300">•</span>}
                  {s}
                </span>
              ))}
            </div>

            {/* Qualificação de posicionamento */}
            <div className="flex flex-col gap-2 mb-7">
              <div className="inline-flex items-center gap-2.5 text-[13px] text-foreground-700">
                <i className="ri-building-2-line text-primary-500 text-base flex-shrink-0"></i>
                <span>Soluções para projetos corporativos de maior porte.</span>
              </div>
              <div className="inline-flex items-center gap-2.5 text-[13px] text-foreground-600 font-medium">
                <i className="ri-arrow-right-up-line text-primary-500 text-base flex-shrink-0"></i>
                <span>Atendimento prioritário para projetos <strong className="text-foreground-800">a partir de R$ 50 mil</strong>.</span>
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="#analise"
                onClick={() => trackEvent('form_start', { source: 'hero' })}
                className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-[15px] px-7 py-4 rounded-full transition-colors whitespace-nowrap cursor-pointer"
              >
                Solicitar análise do ambiente
                <i className="ri-arrow-right-line text-lg"></i>
              </a>
              <a
                href={`${WHATSAPP_BASE}?text=${WHATSAPP_GENERIC_MESSAGE}`}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackEvent('whatsapp_carpete', { location: 'hero' })}
                className="inline-flex items-center justify-center gap-2 text-foreground-800 font-semibold text-[15px] px-7 py-4 rounded-full border border-foreground-200 hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-lg"></i>
                Falar com um especialista
              </a>
            </div>
          </div>

          {/* Imagem */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden bg-background-100 aspect-[4/5] lg:aspect-[5/6]">
              <img
                src="/media/ia/0474.webp"
                alt="Carpete corporativo em ambiente de escritório premium"
                fetchPriority="high"
                decoding="async"
                className="w-full h-full object-cover object-top"
              />
            </div>

            {/* Card flutuante discreto */}
            <div className="absolute -bottom-5 left-5 md:left-8 bg-white/90 backdrop-blur-xl border border-background-200/60 rounded-xl px-5 py-4 max-w-[240px]">
              <p className="text-[11px] font-semibold uppercase tracking-wider text-primary-500 mb-1">
                Atendimento
              </p>
              <p className="text-foreground-700 text-[13px] leading-snug">
                Pernambuco e todo o Nordeste, conforme porte e logística.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}